import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  if (["post", "put", "patch", "delete"].includes(config.method)) {
    const match = document.cookie.match(/(?:^|; )csrf_token=([^;]*)/);
    if (match) config.headers["X-CSRF-Token"] = decodeURIComponent(match[1]);
  }
  return config;
});

export default api;
